const styles = (theme) => ({
  listItem: {
    fontWeight: 700,
    padding: '20px 5px 20px 0',
    color: theme.palette.text.secondary,
  },
});

export default styles;
